import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phoneNumber = "919110725125";
  const message = encodeURIComponent("Hi, I'm interested in learning more about Ultimate Infusions' beverage solutions.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BD5A] flex items-center justify-center shadow-lg shadow-green-500/30 hover:scale-110 transition-all duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={26} className="text-white" />
      {/* Tooltip */}
      <span className="absolute right-full mr-3 bg-white text-slate-800 text-xs font-medium px-3 py-1.5 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Chat with us
      </span>
    </a>
  );
}
